import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import { type AllChainConfig } from '../configTypes';

export const sui = {
  displayName: 'Sui',
  runtime: 'sui',
  isSupported: true,
  isMainnet: true,
  isReleased: false,
  decoration: {
    color: '#4CA2FF',
    contrastColor: getContrastColor('#4CA2FF'),
  },
  orderPriority: 99,
  features: {
    wallet: { supported: true, import: true },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: { chainKey: 'sui-mainnet' },
    },
    blockExplorers: {
      primary: {
        base: 'https://suiscan.xyz/mainnet',
        token: 'https://suiscan.xyz/mainnet/coin',
      },
      alternates: [
        {
          base: 'https://suiexplorer.com/txblock',
          token: 'https://suiexplorer.com/coin',
        },
      ],
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    bluefin: {
      chainKey: 'sui',
    },
    mayan: {
      chainKey: '1999',
      blockExplorerKey: '/mainnet',
    },
  }),
  services: defaultServices({
    codex: {
      networkId: 101,
      nativeLiquidityAddress: '0x2',
    },
    defiLlama: { chainKeys: ['sui'] },
    trm: { chainKey: 'sui' },
    coingecko: {
      networkId: 'sui',
      platformId: 'sui',
    },
    coingeckoDex: {
      networkId: 'sui-network',
    },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'sui', true>;
